import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { insideItems } from '../data/gallery';
const imagine = ['Imagine explaining balance — strong, sweet, sour and diluted — with one clear chart.', 'Walking students through a perfect shake and double strain step by step.', 'Showing the right glass, ice and garnish for every classic side by side.', 'Comparing a correct and an incorrect pour at a glance.', 'And connecting every technique to real service on a busy Saturday night.'];
export function VisualSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-332" data-mp="3g9xphg6x6q3l">
      <div className="max-w-5xl mx-auto" data-id="element-333" data-mp="3gaz4fvr23wql">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid md:grid-cols-[1fr_1.4fr] gap-8 md:gap-12 items-start" data-id="element-334" data-mp="3l8s6qdp8o6ll">
          <div data-id="element-335" data-mp="erll22yh90xv">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-5 text-[#1F4D3A] uppercase" data-id="element-336" data-mp="er2f7km3q307">
              See What You&apos;re Teaching
            </h2>
            <p className="text-xl font-semibold text-[#1F4D3A] mb-1" data-id="element-337" data-mp="9uljo5ckomd3">Bartending Is Hard to Explain With Words.</p>
            <p className="text-xl font-semibold text-[#9C7726] mb-5" data-id="element-338" data-mp="jqornru3vf7y">
              Your Training Materials Shouldn&apos;t Be.
            </p>
            <div className="space-y-3 text-slate-700 leading-relaxed" data-id="element-339" data-mp="3s7jiua1jjb67">
              <p data-id="element-340" data-mp="3n7x94akx8d25">{imagine.join(' ')}</p>
              <p className="font-semibold text-[#1F4D3A]" data-id="element-341" data-mp="3n8yjsdy0yxjc">
                That&apos;s the advantage of a 100% visual training system.
              </p>
              <p data-id="element-342" data-mp="2xu69zktfe9">
                <span className="font-semibold text-[#84651F]" data-id="element-343" data-mp="2fnejfafis3">
                  BARTENDING &amp; MIXOLOGY INSTRUCTOR ATLAS
                </span>{' '}
                is built around illustrations, labeled diagrams, cocktail specs, numbered breakdowns, ❌/✅
                comparisons, teaching cues, drills and quick checks.
              </p>
            </div>
          </div>

          <div className="bg-[#FBF6EF] border border-slate-200 rounded-2xl p-6" data-id="element-344" data-mp="1cf34g1cg22bh">
            <p className="text-sm font-bold text-[#84651F] uppercase tracking-wider mb-4" data-id="element-345" data-mp="1cd05grtbcyum">
              Inside you’ll find:
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-346" data-mp="1m44gxhjs61kp">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-347" data-mp="oip8bjkzk8z5">
                  <CheckCircle2 size={16} className="text-[#9C7726] shrink-0 mt-0.5" data-id="element-348" data-mp="thjpkh3b1ph5" />
                  <span data-id="element-349" data-mp="yfbs051kstzl">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <p className="text-center text-2xl md:text-4xl font-extrabold tracking-tight text-[#1F4D3A] mt-14" data-id="element-350" data-mp="13g9a6hml5o13">
          <span className="text-[#9C7726]" data-id="element-351" data-mp="29ugxthx078nf">100% VISUAL.</span> PRACTICAL. PROFESSIONAL.{' '}
          <span className="bg-[#1F4D3A] text-white px-2 box-decoration-clone" data-id="element-352" data-mp="2esa1a36x9ok0">BUILT TO TEACH.</span>
        </p>
      </div>
    </section>;
}